import { useId, useState } from 'react';
import { TransitionGroup } from 'react-transition-group';
import { ToggleGroup } from '@ui/kit';
import { usePrintedAST, textNodeToJsxPrinter, makeHtmlNodeToJsxPrinter, generateJsxKey } from '@utils/ast';
import { CSSRefTransition } from '@utils/react';
import { usePageContext } from '../../../../context.js';
import { useTaskContext } from '../../context.js';
import { IntroductionSplitView } from '../../molecule.introduction/container.split-view.js';
import { linebreak, wrapper, toggle, transitionWrapper, content, crossfadeDurationMs } from './_task.dropdown.style.js';
import { DropdownInput } from './input.dropdown.js';
import { WordDropdownInput } from './input.word-dropdown.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function isLastInputNode(node, context) {
  if (context.parentNode) {
    return false;
  }
  const inputSiblings = context.siblingNodes.filter(it => it.nodeType !== "text" && it.nodeType !== "html");
  return inputSiblings.indexOf(node) === inputSiblings.length - 1;
}
function SelectAnswersDropdownTask(props) {
  const pageContext = usePageContext();
  const context = useTaskContext();
  const id = useId();
  const [tab, setTab] = useState("answer");

  // The dropdown task historically has supported to differrent types of tasks.
  // In this viewer we wish to differentiate slightly between these.
  // See ADO #125710
  const taskMode = !props.task.content.some(it => it.nodeType === "dropdown-input") ? "sentence-analysis" : "dropdown";
  const content$1 = usePrintedAST(props.task.content, {
    text: textNodeToJsxPrinter,
    html: makeHtmlNodeToJsxPrinter({
      handleTag(tag, data, context) {
        switch (tag) {
          case "br":
            return /*#__PURE__*/jsx("span", {
              className: linebreak,
              children: " "
            }, generateJsxKey(context));
        }
      },
      skipLeadingBRs: true,
      skipTrailingBRs: true
    }),
    "dropdown-input": (node, context) => /*#__PURE__*/jsx(DropdownInput, {
      node: node,
      taskEntryKey: props.taskEntryKey,
      isLastInput: isLastInputNode(node, context)
    }, generateJsxKey(context)),
    "word-dropdown-input": (node, context) => /*#__PURE__*/jsx(WordDropdownInput, {
      node: node,
      taskEntryKey: props.taskEntryKey,
      isLastInput: isLastInputNode(node, context),
      facitType: tab === "facit" ? "should-have" : "user-entry"
    }, generateJsxKey(context))
  }, undefined, [tab]);
  return /*#__PURE__*/jsx(IntroductionSplitView, {
    task: props.task,
    children: /*#__PURE__*/jsxs("div", {
      className: wrapper,
      "data-tab": tab,
      "data-task-mode": taskMode,
      "data-context": context,
      "data-page-context": pageContext,
      children: [taskMode === "sentence-analysis" && pageContext !== "print" && context === "facit" && /*#__PURE__*/jsx("div", {
        className: toggle,
        children: /*#__PURE__*/jsx(ToggleGroup, {
          baseId: id,
          label: "V\xE6lg visningstilstand",
          onTabClick: setTab,
          selectedTabId: tab,
          tabs: [{
            id: "answer",
            title: "Mit svar"
          }, {
            id: "facit",
            title: "Rigtigt svar"
          }]
        })
      }), /*#__PURE__*/jsx(TransitionGroup, {
        component: "div",
        className: transitionWrapper,
        children: /*#__PURE__*/jsx(CSSRefTransition, {
          classNames: content,
          timeout: crossfadeDurationMs,
          children: ref => /*#__PURE__*/jsx("div", {
            className: content,
            ref: ref,
            children: content$1
          })
        }, tab)
      })]
    })
  });
}

export { SelectAnswersDropdownTask };
//# sourceMappingURL=_task.dropdown.js.map
